
// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import { useTranslation } from "react-i18next";
// Soft UI Dashboard React icons
import Shop from "reusableComponents/Icons/Shop";
import Document from "./reusableComponents/Icons/Document";
import { FaUserTie } from "react-icons/fa6";
import PaymentList from "./mainComponents/payment/PaymentList";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import AgentDigitizations from "layouts/agent-publications";
import { FaUsersCog } from 'react-icons/fa';
import ServicesList from "./layouts/services/ServicesList";
import TranslationComponent from "layouts/translation-component";
import { MdMiscellaneousServices } from "react-icons/md";
import FeedbackList from "./reusableComponents/Feedback/FeedbackList";
import { VscFeedback } from "react-icons/vsc";
import { FaLanguage } from "react-icons/fa";
import FreeAgents from "./mainComponents/freeAgents/FreeAgents";

export default function sideBarItems() {
    const { t, i18n } = useTranslation('sideNav');
    const currentLang = i18n.language;

    const p = (path) => `/${currentLang}${path}`;

    return {
    'super-admin':
        [
            {
                type: "collapse",
                name: "Dashboard",
                key: "dashboard",
                route: p("/dashboard"),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Manage free agents",
                key: "free-agents",
                route: p("/free-agents"),
                icon:<FaUsersCog size="14px" />,
                component: <FreeAgents/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Agent Digitizations",
                key: "agent-digitizations",
                route: p("/agent-digitizations"),
                icon: <FaUserTie size="12px"/>,
                component: <AgentDigitizations/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Payment list",
                key: "payment-list",
                route: p("/payment-list"),
                icon: <FaFileInvoiceDollar size="12px"/>,
                component: <PaymentList/>,
                noCollapse: true,
            },
            {
            type: "collapse",
            name: "Services List",
            key: "services-list",
            route: p("/services-list"),
            icon: <MdMiscellaneousServices size="12px"/>,
            component: <ServicesList />,
            noCollapse: true,
            },
            {
                type: "collapse",
                name: "Manage feedback List",
                key: "feedback-list",
                route: p("/feedback-list"),
                icon: <VscFeedback size="12px"/>,
                component: <FeedbackList />,
                noCollapse: true,
            }
        ],
    'free-agent':
        [
            {
                type: "collapse",
                name: t('dashboard', {ns:'sideNav'}),
                key: "dashboard",
                route: p('/dashboard'),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('digitalDatabase', {ns:'sideNav'}),
                key: "documents",
                route: p('/documents'),
                icon: <Document size="12px" />,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('invoices', {ns:'sideNav'}),
                key: "invoices",
                route: p('/invoices'),
                icon: <FaFileInvoiceDollar size="12px"/>,
                component: <PaymentList/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('translation service', {ns:'sideNav'}),
                key: "translation-service",
                route: p('/translation-service'),
                icon: <FaLanguage size="16px"/>,
                component: <TranslationComponent/>,
                noCollapse: true,
            }
        ]
    };
}

